import React, { useState } from 'react';
import { Button } from '@warehouse/shared/legacy-ui';
import styled, { css } from 'styled-components';
import { DialogContent, Typography } from '@mui/material';
import Icon from '@mdi/react';
import { mdiCheckboxMarkedCircle, mdiCloseCircle, mdiDelete } from '@mdi/js';
import { useDeleteTitle } from '../../../../src/utils/hooks/titles/useDeleteTitle';
import Dialog from '../../../../src/components/library/Dialog';
import DialogTitle from '../../../../src/components/library/DialogTitle';
import Loader from '../../../../src/components/library/Loader';
import DialogActions from '../../../../src/components/library/DialogActions';

type Props = {
	uuid: string;
};

export function DeleteTitleButton({ uuid }: Props) {
	const [confirmOpen, setConfirmOpen] = useState(false);
	const { deleteTitle, loading } = useDeleteTitle();

	return (
		<ButtonWrapper>
			<Button onClick={() => setConfirmOpen(true)} nxstyle="secondary-red" disabled={loading} aria-label="Delete Title">
				<Icon path={mdiDelete} size="25px" />
			</Button>
			<Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} fullWidth maxWidth="sm">
				<DialogTitle>Delete Title?</DialogTitle>
				<DialogContent aria-label="confirm-modal-content">
					<TextWrapper>
						<Typography>Are you sure you want to delete this title? This action cannot be undone.</Typography>
					</TextWrapper>
				</DialogContent>
				<DialogActions>
					<Button
						nxstyle="secondary-black"
						onClick={() => setConfirmOpen(false)}
						disabled={loading}
						endIcon={<Icon path={mdiCloseCircle} size="16px" />}
					>
						Cancel
					</Button>
					<Button
						nxstyle="primary-red"
						onClick={() => deleteTitle(uuid)}
						disabled={loading}
						endIcon={loading ? <Loader size={20} color="#fff" /> : <Icon path={mdiCheckboxMarkedCircle} size="16px" />}
					>
						{loading ? 'Deleting...' : 'Delete'}
					</Button>
				</DialogActions>
			</Dialog>
		</ButtonWrapper>
	);
}
const ButtonWrapper = styled.div`
	margin-top: auto;
	text-align: right;
`;
const TextWrapper = styled.div`
	${({ theme }) => css`
		padding: ${theme.spacing(2)} ${theme.spacing(3)} 0;
	`}
`;
